import styled from '@emotion/styled'
import CommonButton from '@/components/common/Button'

export const ContainerCard = styled('div')`
  margin: 24px auto;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 24px 32px;
  width: 100%;
  position: relative;
  user-select: none;
`

export const HeaderWrapper = styled('div')`
  display: flex;
  justify-content: end;
  align-content: center;
  margin-bottom: 24px;
`

export const Button = styled(CommonButton)`
  line-height: 20px;
  padding: 10px 16px;
`

export const IconSvg = styled('img')`
  margin-right: 10px;
  height: 15px;
  width: 15px;
`

export const DeleteIcon = styled('img')`
  height: 20px;
  width: 20px;
  cursor: pointer;
`

export const EditIcon = styled('img')`
  cursor: pointer;
  width: 20px;
  height: 20px;
`

export const ToolWrapper = styled('div')`
  display: flex;
  justify-content: right;
  gap: 8px;
`
